import Axios from 'axios';
import { Config } from '../apiRoutes';

import {
  SUGGESTED_PURCHASE_ORDER_INDEX_REQUESTED,
  SUGGESTED_PURCHASE_ORDER_INDEX_SUCCESS,
  SUGGESTED_PURCHASE_ORDER_INDEX_FAILURE,
  SUGGESTED_PURCHASE_ORDER_FIND_REQUESTED,
  SUGGESTED_PURCHASE_ORDER_FIND_SUCCESS,
  SUGGESTED_PURCHASE_ORDER_FIND_FAILURE,
  SUGGESTED_PURCHASE_ORDER_CREATE_REQUESTED,
  SUGGESTED_PURCHASE_ORDER_CREATE_SUCCESS,
  SUGGESTED_PURCHASE_ORDER_CREATE_FAILURE,
  SUGGESTED_PURCHASE_ORDER_MARK_COMPLETE_REQUESTED,
  SUGGESTED_PURCHASE_ORDER_MARK_COMPLETE_SUCCESS,
  SUGGESTED_PURCHASE_ORDER_MARK_COMPLETE_FAILURE,
} from '../types';

export const suggestedPurchaseOrderIndexRequested = () => {
  return {
    type: SUGGESTED_PURCHASE_ORDER_INDEX_REQUESTED
  }
};

export const suggestedPurchaseOrderIndexSuccess = (suggestedPurchaseOrders, page) => {
  return {
    type: SUGGESTED_PURCHASE_ORDER_INDEX_SUCCESS,
    payload: suggestedPurchaseOrders,
    page: page
  }
};

export const suggestedPurchaseOrderIndexFailure = () => {
  return {
    type: SUGGESTED_PURCHASE_ORDER_INDEX_FAILURE
  }
};

export const suggestedPurchaseOrderFindRequested = () => {
  return {
    type: SUGGESTED_PURCHASE_ORDER_FIND_REQUESTED
  }
};

export const suggestedPurchaseOrderFindSuccess = (suggestedPurchaseOrder) => {
  return {
    type: SUGGESTED_PURCHASE_ORDER_FIND_SUCCESS,
    payload: suggestedPurchaseOrder
  }
};

export const suggestedPurchaseOrderFindFailure = () => {
  return {
    type: SUGGESTED_PURCHASE_ORDER_FIND_FAILURE
  }
};

export const suggestedPurchaseOrderCreateRequested = () => {
  return {
    type: SUGGESTED_PURCHASE_ORDER_CREATE_REQUESTED
  }
};

export const suggestedPurchaseOrderCreateSuccess = (suggestedPurchaseOrder) => {
  return {
    type: SUGGESTED_PURCHASE_ORDER_CREATE_SUCCESS,
    payload: suggestedPurchaseOrder
  }
};

export const suggestedPurchaseOrderCreateFailure = () => {
  return {
    type: SUGGESTED_PURCHASE_ORDER_CREATE_FAILURE
  }
};

export const suggestedPurchaseOrderCompleteRequested = () => {
  return {
    type: SUGGESTED_PURCHASE_ORDER_MARK_COMPLETE_REQUESTED
  }
}

export const suggestedPurchaseOrderCompleteSuccess = (payload) => {
  return {
    type: SUGGESTED_PURCHASE_ORDER_MARK_COMPLETE_SUCCESS,
    payload: payload
  }
}

export const suggestedPurchaseOrderCompleteFailure = () => {
  return {
    type: SUGGESTED_PURCHASE_ORDER_MARK_COMPLETE_FAILURE
  }
}


export const suggestedPurchaseOrdersIndex = (signedPayload, continuationToken, page) => {
  return (dispatch) => {
    dispatch(suggestedPurchaseOrderIndexRequested());

    let endPoint = Config.baseUrl + Config.suggestedPurchaseOrder;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    if (continuationToken) {
      endPoint = endPoint + `?continuation_token=${continuationToken}`;
    }

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(suggestedPurchaseOrderIndexSuccess(response.data, page));
      })
      .catch((error) => {
        dispatch(suggestedPurchaseOrderIndexFailure());
      });
  }
}

export const createSuggestedPurchaseOrder = (signedPayload, supplier, address) => {
  return (dispatch) => {
    dispatch(suggestedPurchaseOrderCreateRequested());

    let endPoint = Config.baseUrl + Config.suggestedPurchaseOrder;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    let body = {
      supplier_id: supplier,
      location_id: address
    }

    return Axios.post(endPoint, body, { headers: headers })
      .then((response) => {
        dispatch(suggestedPurchaseOrderCreateSuccess(response.data));
      })
      .catch((error) => {
        dispatch(suggestedPurchaseOrderCreateFailure());
      });
  }
}

export const findSuggestedPurchaseOrder = (signedPayload, suggestedOrderId) => {
  return (dispatch) => {
    dispatch(suggestedPurchaseOrderFindRequested());

    let endPoint = Config.baseUrl + Config.suggestedPurchaseOrder + '/' + suggestedOrderId;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(suggestedPurchaseOrderFindSuccess(response.data));
      })
      .catch((error) => {
        dispatch(suggestedPurchaseOrderFindFailure());
      });
  }
}

export const markComplete = (signedPayload, suggestedOrderId) => {
  return (dispatch) => {
    dispatch(suggestedPurchaseOrderCompleteRequested());

    let endPoint = Config.baseUrl + Config.suggestedPurchaseOrder;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.put(endPoint, { suggestedOrderId: suggestedOrderId }, { headers: headers })
      .then((response) => {
        dispatch(suggestedPurchaseOrderCompleteSuccess(response.data));
      })
      .catch((error) => {
        dispatch(suggestedPurchaseOrderCompleteFailure());
      });
  }
}

